import { render } from "./DemandTemplateDeleteButton.vue?vue&type=template&id=d0369e04"
import script from "./DemandTemplateDeleteButton.vue?vue&type=script&lang=ts"
export * from "./DemandTemplateDeleteButton.vue?vue&type=script&lang=ts"
script.render = render

export default script